import React from "react";
import clsx from "clsx";

import { ReactComponent as SettingIcon } from "../../../../assets/svg/setting.svg";
import { ILesson } from "../../../../state";
import styles from "../SelectPage.module.scss";

interface IPublishControlsProps {
  activeLesson: ILesson;
  roundNo: number;
  calling: boolean;
  onPublishLesson: (lesson_id: number, roundNo: number) => void;
  onUnPublishLesson: (lesson_id: number, roundNo: number) => void;
  onOpenSettingModal: () => void;
}

const PublishControls = ({
  activeLesson,
  roundNo,
  calling,
  onPublishLesson,
  onUnPublishLesson,
  onOpenSettingModal,
}: IPublishControlsProps) => {
  const activeRound = activeLesson.rounds?.find(
    round => round.round_no === roundNo,
  );
  return (
    <div className={styles.publishControls}>
      <button
        className={clsx(
          styles.publishBtn,
          activeRound?.published && styles.active,
        )}
        onClick={() => {
          if (!activeRound?.published) {
            onPublishLesson(activeLesson.id, roundNo);
          }
        }}
        disabled={calling}
      >
        生徒に公開する
      </button>
      <button
        className={clsx(
          styles.unpublishBtn,
          !activeRound?.published && styles.active,
        )}
        onClick={() => {
          if (activeRound?.published) {
            onUnPublishLesson(activeLesson.id, roundNo);
          }
        }}
        disabled={calling}
      >
        公開しない
      </button>
      <button
        className={styles.settingBtn}
        disabled={calling}
        onClick={onOpenSettingModal}
      >
        <SettingIcon />
      </button>
    </div>
  );
};

export default PublishControls;
